/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toast_Pos_Order_ErrorInputs */

const vi_toast_pos_order_error = /** @type {(inputs: Toast_Pos_Order_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đặt hàng thất bại`)
};

/**

* @param {Toast_Pos_Order_ErrorInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const toast_pos_order_error = /** @type {((inputs?: Toast_Pos_Order_ErrorInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toast_Pos_Order_ErrorInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_toast_pos_order_error(inputs)
});